import axios from 'axios'
import * as config from '../config'

export const ADMIN_COMPANY_SET = "ADMIN_COMPANY_SET"
export const ADMIN_COMPANY_RESET = "ADMIN_COMPANY_RESET"
export const ADMIN_COMPANY_CHANGE = "ADMIN_COMPANY_CHANGE"
export const ADMIN_COMPANY_ADD_EMAILPRESET = "ADMIN_COMPANY_ADD_EMAILPRESET"
export const ADMIN_COMPANY_SETTINGS_CHANGE = "ADMIN_COMPANY_SETTINGS_CHANGE"


export function Get(id){
    return (dispatch) =>{
        axios.get(
            config.apiUrl + "/companies/get",
            {
                params:{
                    companyId:id
                }
            }
        )
        .then((response)=>{
            dispatch({
                type:ADMIN_COMPANY_SET,
                payload:response.data.content
            })
        })
    }
}

export function Reset(){
    return (dispatch) =>{
        dispatch({
            type:ADMIN_COMPANY_RESET
        })
    }
}

export function Change(field,value){
    return (dispatch) =>{
        dispatch({
            type:ADMIN_COMPANY_CHANGE,
            payload:{
                field,
                value
            }
        })
    }
}


export function ChangeSettings(field,value){
    return (dispatch) =>{
        dispatch({
            type:ADMIN_COMPANY_SETTINGS_CHANGE,
            payload:{
                field,
                value
            }
        })
    }
}

export function AddEmailPreset(email){
    return(dispatch)=>{
        dispatch({
            type:ADMIN_COMPANY_ADD_EMAILPRESET,
            payload:email
        })
    }
}




// WEBPACK FOOTER //
// ./src/actions/adminCompanyActions.js